export default __webpack_public_path__ + "static/media/add-ride-page1400.d782c878.jpg";